import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LoaderColors, LoaderSize } from '../loaders.model';

@Component({
  selector: 'mib-spinner',
  templateUrl: './spinner.component.html',
  host: {
    class: 'flex',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MibSpinnerComponent {
  readonly overlay = input(false, { transform: booleanAttribute });
  readonly size = input<LoaderSize>('medium');
  readonly color = input<LoaderColors>('primary');

  readonly sizeClasses = computed(() => {
    switch (this.size()) {
      case 'small':
        return 'w-4 h-4';
      case 'large':
        return 'w-8 h-8';
      case 'xl':
        return 'w-10 h-10';
      case 'medium':
      default:
        return 'w-6 h-6';
    }
  });

  readonly colorClass = computed(() => {
    switch (this.color()) {
      case 'primary':
        return 'text-mib-primary';
      case 'secondary':
        return 'text-gray-700';
      case 'danger':
        return 'text-error';
      case 'warning':
        return 'text-orange-600';
      case 'success':
        return 'text-success';
      case 'light':
        return 'text-gray-200';
    }
  });

  readonly overlayClasses = computed(() => {
    if (this.overlay()) {
      return 'absolute top-0 left-0 inset-0 z-50 flex items-center justify-center bg-black/30 text-gray-50';
    } else {
      return '';
    }
  });
}
